import React, { memo } from 'react'

import CardBody from '../../../../UI/Card/Body/Body'
import StructureCard from './StructureCard/StructureCard'
import Collapse from '../../../../../components/UI/Collapse/Collapse'

const SetupCompetencyScoreBody = ({
  recordKey,
  adding,
  editing,
  deleting,
  competencyData,
  loading,
  addDisabled,
  editDisabled,
  deleteDisabled,
  collap,
  collapseCheck,
  open,
  deletingGroup,
  editingGroup,
  actionCheck,
  eftdText
}) => {
  let competencyCards = competencyData.map(competencyItem => {
    const competencyId = competencyItem.csg_id
    let collapp = open.find(item => item.csg_id === competencyId)
    if (collapp.csg_id === collapseCheck) {
      if (actionCheck === true) collapp.open = false
    }
    if (competencyItem.competency_score) {
      competencyItem.competency_score = competencyItem.competency_score.sort(
        (a, b) => +b.score - +a.score
      )
    }
    let children = (
      <StructureCard
        key={competencyItem.csg_id}
        structureKey={competencyItem.csg_id}
        structureData={competencyItem.competency_score}
        // structureType={structureType}
        adding={() => adding(competencyId)}
        editing={recordId => editing(recordId, competencyId)}
        deleting={deleting}
        recordKey={recordKey}
        loading={loading}
        addDisabled={addDisabled}
        editDisabled={editDisabled}
        deleteDisabled={deleteDisabled}
      />
    )

    return (
      <Collapse
        key={competencyId}
        title={competencyItem.csg_name}
        effective_date={competencyItem.effective_date}
        show={collapp.open}
        editingGroup={() => editingGroup(competencyId)}
        deletingGroup={() => deletingGroup(competencyId)}
        toggleBarClicked={() => collap(competencyId)}
        actionCheck={actionCheck}
        competencyAction={true}
        eftdText={eftdText}
        children={children}></Collapse>
    )
  })

  let SetupCompetencyScoreBody = <CardBody>{competencyCards}</CardBody>

  return SetupCompetencyScoreBody
}

export default memo(SetupCompetencyScoreBody)
